<template>
    <div class="reservation-member-card">
        <img v-if="member.avatar" :src="getAvatarUrl()" :alt="$t('calendar.avatarImageAlt')" style="width:200px" />
        <div v-else class="no-avatar">{{ $t('calendar.noAvatar') }}</div>
        <div class="member-info">
            <h3>{{ member.name }}</h3>
            <p>{{ member.title }}</p>
            <p>{{ member.description }}</p>
        </div>
        <div class="member-actions">
            <SupsisButton ghost @click="$emit('edit')">{{ $t('message.edit')}}</SupsisButton>
            <SupsisButton danger @click="$emit('delete')">{{ $t('message.delete')}}</SupsisButton>
            <SupsisButton @click="$emit('move-up')">{{ $t("message.moveLeft") }}</SupsisButton>
            <SupsisButton @click="$emit('move-down')">{{$t("message.moveRight")}}</SupsisButton>
        </div>
    </div>
</template>

<script>
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "ReservationMemberCard",
    components: {
        SupsisButton,
    },
    props: {
        member: {
            type: Object,
            required: true,
        },
    },
    emits: ["edit", "delete", "move-up", "move-down"],
    methods: {
        getAvatarUrl() {
            if (!this.member.avatar) return '';
            return this.member.avatar.v2Format && this.member.avatar.cdnUrl
                ? this.member.avatar.cdnUrl
                : `https://static.supsis.live/${this.member.avatar.path}${this.member.avatar._id}.${this.member.avatar.ext}`;
        }
    }
};
</script>

<style scoped lang="scss">
.reservation-member-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    min-width: 200px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;

    .no-avatar {
        width: 100px;
        height: 100px;
        background-color: #f0f0f0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
    }

    .member-info {
        text-align: center;
        margin-top: 10px;

        h3 {
            font-size: 1.2em;
            margin-bottom: 5px;
        }

        p {
            font-size: 1em;
            margin: 0;
        }
    }

    .member-actions {
        display: flex;
        gap: 10px;
        margin-top: 10px;
    }
}
</style>
